import React, { useEffect, useState } from "react";
import GetMonthsOpt from "../Dropdowns/getSelectMonth.js";
import GetYearsOpt from "../Dropdowns/getSelectYear.js";
import GetDistricts from "../Dropdowns/getDistricts.js";
import FPSCommissionSummaryDownload from "./FPSCommissionSummaryDownload.jsx";
import axios from "axios";

const FPSCommissionSummary = () => {
  const [loading, setLoading] = useState(true);
  const [selectedDistCode, setSelectedDistCode] = useState("");
  const [loadingDistricts, setLoadingDistricts] = useState(false); 
  const [renderContent, setRenderContent] = useState(null);
  const [sessionExpired, setSessionExpired] = useState(false);
  const [sessionLoading, setSessionLoading] = useState(true);
  const [userName, setUserName] = useState("");

  useEffect(() => {    
        axios
          .get(`${process.env.REACT_APP_URL}/api/ekyc-abstract/session-info`, {
            withCredentials: true,
          })
          .then((res) => {
            setUserName(res.data.userName);
            setSessionExpired(false);
          })
          .catch((err) => {
            setSessionExpired(true);
          })
          .finally(() => {
            setSessionLoading(false);
          }); 
       
        }, []);       

    const handleMonthsLoadingChange = (isLoading) => {
      handleLoadingChange(isLoading);
    };

    const handleLoadingChange = (isLoading) => {
      setLoading(isLoading);
    };

    const handleYearsLoadingChange = (isLoading) => {
      handleLoadingChange(isLoading);
    };

    const handleDistrictChange = (dist_code) => {
    setSelectedDistCode(dist_code);
  };



   const handleSubmit = async (action) => {

    const month = document.getElementById("month").value;
    const year = document.getElementById("year").value;
    const allot_month = document.getElementById("allot_month").value;
    const allot_year = document.getElementById("allot_year").value;
    const distCode = document.getElementById("dist_code").value;   
    const distMonthName = document.getElementById("month").options[document.getElementById("month").selectedIndex].text;
    const alotMonthName = document.getElementById("allot_month").options[document.getElementById("allot_month").selectedIndex].text;
    const districtName = document.getElementById("dist_code").options[document.getElementById("dist_code").selectedIndex].text;  

    if (month == null || month == "") {
      alert("Please select Distribution Month");
      return false;
    } else if (year == null || year == "")
    {
      alert("Please select Distribution Year");
      return false;
    } 
     if (allot_month == null || allot_month == "") {
      alert("Please select Allotment Month");
      return false;
    } else if (allot_year == null || allot_year == "")
    {
      alert("Please select Allotment Year");
      return false;
    } 
    else if(distCode == null || distCode == "")
    {
      alert("Please select District");
      return false;
    }
    else
      {
      setRenderContent(null);
      setRenderContent(
          <FPSCommissionSummaryDownload
            month={month}
            year={year}
            allotMonth={allot_month}
            allotYear={allot_year}
            distCode={distCode}
            distMonthName={distMonthName}
            alotMonthName={alotMonthName}
            districtName={districtName}
            userName={userName}
            action={action}
          />
        );
    } 
   }


  return (
    <>
      <div
        className="wrapper row3"
        style={{ maxHeight: "95vh", paddingBottom: "40px" }}
      >
        {" "}
      </div>

      <div id="container">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "10px",
          }}
        >

        <table width="65%">
          <thead>
            <tr className="tableheader">
              <th colSpan={10}>Generate Bank Statement for State</th>
            </tr>
          </thead>
          <tbody>
          <tr>
            <td>Distribution Month :</td>
                <td>
                  <GetMonthsOpt
                    input_id="month"
                    onLoadingChange={handleMonthsLoadingChange}
                  />
                </td>
                <td>Distribution Year:</td>
                <td>
                  <GetYearsOpt
                    input_id="year"
                    onLoadingChange={handleYearsLoadingChange}
                  />
                </td>
                 <td>Allotted Month :</td>
                <td>
                  <GetMonthsOpt
                    input_id="allot_month"
                    onLoadingChange={handleMonthsLoadingChange}
                  />
                </td>
                <td>Allotted Year:</td>
                <td>
                  <GetYearsOpt
                    input_id="allot_year"
                    onLoadingChange={handleYearsLoadingChange}
                  />
                </td>
                 <td>District :</td>
                <td>
                  <GetDistricts
                      onLoadingChange={setLoadingDistricts}
                      onChange={handleDistrictChange}
                    />
                </td>
              </tr>
                <tr>
                  <td colSpan="10" align="center">
                    {
                      <button
                        className="button button2"
                        style={{ marginRight: "10px" }}
                         onClick={() => handleSubmit("generate")}
                      >
                        Generate
                      </button>
                    }

                    <button
                        className="button button2"
                        style={{ marginRight: "10px" }}
                        onClick={() => handleSubmit("regenerate")}
                      >
                        Re-Generate
                      </button>
                    <button
                      className="button button2"
                      onClick={() => window.history.back()}
                    >
                      Back
                    </button>
                  </td>
              </tr>

          </tbody>
        </table>
        </div>
        <br />
        <div id="loading" style={{ display: "none", textAlign: "center" }}>
          <img src="images/progress.gif" alt="Loading" />
        </div>
        <br />
        <div id="fpsCommissionSummaryDownload">{renderContent}</div>
      </div>
    </>
  );
};

export default FPSCommissionSummary;
